import { render, staticRenderFns } from "./LegalsPage.vue?vue&type=template&id=4eed6814"
import script from "./LegalsPage.vue?vue&type=script&lang=js"
export * from "./LegalsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports